import * as types from '../mutation-types/editor-linkable'

const namespaced = true
export const namespace = 'EditorLinkable'

// state
const state = {
    linkableTurnOnActive: false,
    linkableTurnOffActive: false,
}

// mutations
const mutations = {
    [types.SET_TURN_ON_ACTIVE](s, active) {
        s.linkableTurnOnActive = active
    },
    [types.SET_TURN_OFF_ACTIVE](s, active) {
        s.linkableTurnOffActive = active
    },
}

// actions
const actions = {
    setLinkableTurnOnActive({commit}, active) {
        commit(types.SET_TURN_ON_ACTIVE, active)
    },
    setLinkableTurnOffActive({commit}, active) {
        commit(types.SET_TURN_OFF_ACTIVE, active)
    },
}

// getters
const getters = {
    linkableTurnOnActive: s => {
        return s.linkableTurnOnActive
    },
    linkableTurnOffActive: s => {
        return s.linkableTurnOffActive
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
